import { useDispatch } from 'react-redux';
import FJImageToImageRight from './FJImageToImageRight';
import { setSliceIsDraggingFileAction } from '../../../redux/slices/FJSliceCommon';
import FJActionImageToImage from '../../../redux/action/FJActionImageToImage';
import useLocalStore from '../../../hooks/useLocalStore';
import { useSelector } from 'react-redux';

const FJImageToImageRightContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);
    const isEmptyCreationList = useSelector(state => {
        const creationList = state.common.creationList;
        return !creationList || creationList.length === 0;
    });

    const uploadImg = file => {
        dispatch(FJActionImageToImage.uploadImageAction(file));
    };
    const _setIsDraggingFile = value => {
        dispatch(setSliceIsDraggingFileAction(value));
    };

    return (
        <FJImageToImageRight
            uploadImg={uploadImg}
            setIsDraggingFile={_setIsDraggingFile}
            isEmptyCreationList={isEmptyCreationList}
            headerTabIndex={headerTabIndex}
        />
    );
};
export default FJImageToImageRightContainer;
